// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cRL8k"};